export default __webpack_public_path__ + "static/compareItemImg3-99e887f80fcf11fb01d428f6687b9a62.png";